<kendo-dialog *ngIf="editFormActive" (close)="closeEditForm()" [width]="850">
    <kendo-dialog-titlebar>
        <h3>{{ (isNew ? 'ADD-SYSTEM-NOTE' : 'EDIT-SYSTEM-NOTE') | translate }}</h3>
    </kendo-dialog-titlebar>
    <form novalidate [formGroup]="editForm" class="k-form">
        <div class="row">
            <div class="col-12">
                <label class="k-form-field">
                    <span class="k-text-uppercase dark">
                        {{'SYSTEM-NOTE-TEXT' | translate}} *
                    </span>
                    <textarea id="text" kendoTextArea class="w-100" cols="120" rows="5" formControlName="text"
                        maxlength="4000">
                    </textarea>
                    <div class="k-tooltip k-tooltip-validation" role="alert"
                        *ngIf="text.hasError('required') && text.touched">
                        {{'REQUIRED-SYSTEM-NOTE' | translate}}
                    </div>
                </label>
            </div>
        </div>
    </form>
    <div>* {{'REQUIRED-FIELDS' | translate}}</div>
    <kendo-dialog-actions>
        <button class="k-button" (click)="onCancel($event)">{{ 'CANCEL' | translate }}</button>
        <button appPreventClick class="k-button k-primary" [disabled]="!editForm.valid || !editForm.dirty"
            (click)="onSave($event)">{{ 'SAVE' | translate }}
        </button>
    </kendo-dialog-actions>
</kendo-dialog>